<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav" v-if="$route.name!==''">
        <li class="nav-title">
          {{web_texts.sidebar.general_info}}
        </li>
        <li class="nav-item">
          <router-link :to="'/home'" class="nav-link"><i class="icon-home"></i> {{web_texts.sidebar.start}} </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="'/device'" class="nav-link"><i class="icon-screen-smartphone"></i> {{web_texts.sidebar.devices}} </router-link>
        </li>
<!--        TODO Refactor-->
        <li class="nav-item" v-if="system.id!==20">
          <router-link :to="'/shunting'" class="nav-link"><i class="icon-wrench"></i> {{web_texts.sidebar.shunttings}} </router-link>
        </li>
        <li class="nav-title">
          {{web_texts.sidebar.status_system}}
        </li>
        <li class="nav-item">
          <router-link :to="'/notifications'" class="nav-link" exact><i class="icon-bell"></i> {{web_texts.sidebar.notifications}}</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="'/messages'" class="nav-link" exact><i class="icon-speech"></i> {{web_texts.sidebar.messages}}</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="'/events'" class="nav-link" exact><i class="icon-tag"></i> {{web_texts.sidebar.events}}</router-link>
        </li>
        <li class="nav-title">
          {{web_texts.sidebar.informs}}
        </li>
        <li class="nav-item" v-if="system.id!==20">
          <router-link :to="'/maximeter'" class="nav-link" exact><i class="icon-speedometer"></i> {{web_texts.sidebar.maximeters}}</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="'/export_data'" class="nav-link" exact><i class="icon-cloud-download"></i> {{web_texts.sidebar.export_inform}}</router-link>
        </li>
        <li class="nav-item" v-if="system.id!==20">
          <router-link :to="'/energetic_inform'" class="nav-link" exact><i class="icon-credit-card"></i> {{web_texts.sidebar.inf_energetic}}</router-link>
        </li>
        <li class="nav-item" v-if="system.id!==11 && system.id!==19 && user.id===1 && system.id!==20">
          <router-link :to="'/costs_inform'" class="nav-link" exact><i class="icon-credit-card"></i> {{web_texts.sidebar.inf_costs}}</router-link>
        </li>
        <li class="nav-item" v-if="system.id!==11 && system.id!==19 && user.id===1 && system.id!==20">
          <router-link :to="'/invoice_simulation'" class="nav-link" exact><i class="icon-chart"></i> {{web_texts.sidebar.invoice_simulation}}</router-link>
        </li>
        <li class="nav-item" v-if="system.id!==11 && system.id!==19 && user.id===1 && system.id!==20">
          <router-link :to="'/anuall_sumary'" class="nav-link" exact><i class="icon-chart"></i> {{web_texts.sidebar.annually_inform}}</router-link>
        </li>
        <li class="nav-title">
          {{web_texts.sidebar.app_info}}
        </li>
        <li class="nav-item">
          <router-link :to="'/info'" class="nav-link" exact><i class="icon-info"></i> {{web_texts.sidebar.sce_info}}</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
  import trans_cat from '../translates/cat/Components';
  import trans_es from '../translates/es/Components';
  import middleware from "../utilities/middlewares";

  export default {
    name: 'app-sidebar',
    data() {
      return {
        web_texts: { "aside": {}, "breadcrumb": {}, "footer": {}, "sidebar": { "select_system": "Seleccionar Sistema ", "profile": "Perfil", "logout": "Sortir" }, "navbar": { "general_info": "Informació general", "start": "Inici", "devices": "Dispositius", "shunttings": "Maniobres", "status_system": "Estat sistema", "notifications": "Notificacions", "messages": "Missatges", "events": "Esdeveniments", "informs": "Informes i Històrics", "maximeters": "Maxímetre", "export_inform": "Exportar Informació", "inf_energetic": "Inf. Energétic", "inf_costs": "Inf. Costos", "invoice_simulation": "Simulació Factura", "annually_inform": "Inf. Anual", "app_info": "Informació APP", "sce_info": "Informació SCE" }, "header": {} },
        system: {id:0},
        user: {id:0}
      }
    },
    created(){
      this.system=JSON.parse(window.localStorage.getItem('system'));
      this.user=JSON.parse(window.localStorage.getItem('user'));
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
    },
    watch: {
      '$route' (to, from) {
        // react to route changes...
        this.system=JSON.parse(window.localStorage.getItem('system'));
        this.user=JSON.parse(window.localStorage.getItem('user'));
        this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      }
    },
    methods: {
      handleClick(e) {
        e.preventDefault()
        e.target.parentElement.classList.toggle('open')
      }
    }
  }
</script>

<style lang="css">
  .nav-link {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?ed91af5e